import { render, staticRenderFns } from "./sendSteps.vue?vue&type=template&id=a04292a4"
import script from "./sendSteps.vue?vue&type=script&lang=js"
export * from "./sendSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports